// 引入工具函数
import req from '@/utils/request'

// 查询配方单
export const queryFormula = (params) => {
    return req.get('/formula/queryFormula', params)
}

//获取退药记录
export const getFormulaDrugReturn = (params) => {
    return req.get('/formula/drugReturn/getFormulaDrugReturn', params)
}

//获取退药记录
export const editDrugReturn = (params) => {
    return req.post('/formula/drugReturn/editDrugReturn', params)
}

// 处理订单
export const dealOrder = (params) => {
    return req.post('/ctOrder/deal', params)
}

// 处理订单
export const exportOrder = (params, config) => {
    return req.downloadGet('/ctOrder/export', params, config)
}

//分页查询配方单
export const formulaPage = (params) => {
    return req.post('/dc/prescription/delivery/page', params)
}

//更新快递单号
export const upDateDeliveryNumber = (params) => {
    return req.post('/dc/prescription/update/courierNumber', params)
}

//查询配方单详情
export const formulaDetail = (params) => {
    return req.post('/dc/prescription/delivery/detail', params)
}

// 查询配方单中的追溯码药品信息
export const getTraceDrugList = (params) => {
    return req.get('/dc/prescription/getTracecodeDrugByPrescription', params)
}

//拒绝配方
export const refuseFormula = (params) => {
    return req.post('/dc/prescription/reject/prescription', params)
}

//收方
export const receiveFormula = (params) => {
    return req.post('/dc/prescription/receive/prescription', params)
}

// 获取退货数据
export const getReturnGoodsList = (params) => {
    return req.post('/dc/statistic/page/statistic', params)
}

// 导出退货数据
export const returnGoodsExport = (params, config) => {
    return req.downloadGet('/dc/statistic/drugs/export', params, config)
}

// 查询订单配方中的配方单
export const getFormulatingPrescription = (params) => {
    return req.get('/dc/prescription/formulating/prescription', params)
}

// 查询物流订单中提交的信息
export const getTransportOrderInfo = (params) => {
    return req.get('/dc/prescription/logistics/queryReallogistics', params)
}

// 查询物流发货时间列表
export const getTransPortOrderTimeList = (params) => {
    return req.get('/delivery/rules/getDeliveryTime', params)
}

// 查询物流跟踪信息列表
export const getTransPortStepDetail = (params) => {
    return req.get('/logistics/queryLogisticInfo', params)
}

// 查询可合并的配方单列表
export const getMergeList = (params) => {
  return req.get('/logistics/prescription/mergable/list', params)
}
// 查询启用下单的物流公司列表
export const getLogisticsList = (params) => {
  return req.get('/logistics/enable/list', params)
}
// 物流下单
export const logisticsCreateOrder = (params) => {
  return req.post('/logistics/order/create', params)
}
// 批量快递单号更新
export const updateCourierNumberBatch = (params) => {
  return req.post('/dc/prescription/update/courierNumber/batch', params)
}

// 打印快递单
export const printLogistics = (params) => {
  return req.blobDownload(`/logistics/waybill/print`, params, 'application/pdf','/api','post');
  
}

//查询快递打印日志
export const logisticsLog = (params) => {
  return req.get('/logistics/log', params)
}